module.exports = ["normal","italic","oblique"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-font-style-keywords/index.json
// module id = EEKI
// module chunks = 1